import { useDispatch } from "react-redux";
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import './App.css';
import HomePage from './Components/Dashboard/Home/HomePage';
import QuoteRequest from './Components/QuoteRequest/QuoteRequest';
import PageNotFound from './Components/utilities/PageNotFound/PageNotFound'
import ViewRequest from './Components/ViewRequest/ViewRequest';
import Header from './Layout/Header';
import Footer from './Layout/Footer/Footer';
import CountryUploadValidation from './Components/CountryUploadValidation/CountryUploadValidation'
import ViewRequestLink from './Components/ViewRequest/ViewRequestLink';
import ManageData from './Components/ManageData/ManageDataTab/ManageData';
import CompareQuote from './Components/CompareQuote/CompareQuote';
import ManageUsers from "./Components/ManageUsers/ManageUsers/ManageUsers";

import ManageSync from './Components/ManageSync/ManageSync/ManageSync';


import { useMsal, useIsAuthenticated, MsalProvider } from '@azure/msal-react';
import { loginRequest, msalConfig } from "./authConfig";

import { LocalStorageKeys } from './Components/QuoteRequest/Content';
import { getDecryptedText } from "./Actions/CommonAction";
import { checkAndSetOpportunityUserEmailFromQueryString, ORIGIN, SetLoggedInUserDataInSession } from "./Helper/SessionHelper";
import { useEffect, useRef, useState } from "react";
import ManageBundles from "./Components/ManageBundles/ManageBundles";
import { getLoggedUserDetails } from "./Actions/UserAction";
import { Congiguration } from "./Constants/AppConstants";
import Notification from "./Components/utilities/Notification/Notification";

const WappedViewForLogin = () => {
    const { instance, inProgress } = useMsal();
    const isAuthenticated = useIsAuthenticated();
    const initialSearchRef = useRef(window.location.search);
    const hasStartedAuthFlowRef = useRef(false);
    const [networkAlertOpen, setNetworkAlertOpen] = useState(false);
    const [networkAlertMessage, setNetworkAlertMessage] = useState("");
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        const handleNetworkError = (event) => {
            setNetworkAlertMessage(event?.detail?.message || "Unable to reach backend services. Connect to Workplace Options network/VPN and try again.");
            setNetworkAlertOpen(true);
        };

        window.addEventListener('cpq-network-error', handleNetworkError);
        return () => {
            window.removeEventListener('cpq-network-error', handleNetworkError);
        };
    }, []);

    useEffect(() => {
        if (inProgress !== "none" || hasStartedAuthFlowRef.current) {
            return;
        }

        let search = initialSearchRef.current;

        if ((!search || search === '' || search === null) && sessionStorage.getItem(LocalStorageKeys.ENCRYPTEDURL)) {
            search = sessionStorage.getItem(LocalStorageKeys.ENCRYPTEDURL);
        }

        if (search && search !== '' && search !== null
            && !sessionStorage.getItem(LocalStorageKeys.QS_USEREMAIL)) {
            hasStartedAuthFlowRef.current = true;

            sessionStorage.setItem(LocalStorageKeys.ENCRYPTEDURL, search);

            const inputString = search.replace("?", "");

            dispatch(getDecryptedText(inputString))
                .then((result) => {
                    console.log('decr url', result);
                    const params = new URLSearchParams(result);
                    const userEmail = params.get('UserEmail');
                    const opportunityId = params.get('OpportunityId');
                    const isEmail = params.get('IsEmail') === "true";

                    sessionStorage.setItem(LocalStorageKeys.QS_USEREMAIL, userEmail);
                    sessionStorage.setItem(LocalStorageKeys.OPPORTUNITYID, opportunityId);
                    sessionStorage.setItem(LocalStorageKeys.CURRENTWORKINGOPPORTUNITY, opportunityId);
                    localStorage.setItem(LocalStorageKeys.COMPAREOPPORTUNITIESLIST, opportunityId);

                    if (!isAuthenticated) {

                        const requestedLoginHint = (!isEmail || isEmail === null)
                            ? sessionStorage.getItem(LocalStorageKeys.QS_USEREMAIL)
                            : "";
                        const cachedAccount = instance
                            .getAllAccounts()
                            .find((account) => account?.username?.toLowerCase() === requestedLoginHint?.toLowerCase());

                        if (cachedAccount) {
                            instance.acquireTokenSilent({
                                scopes: ["user.read"],
                                account: cachedAccount
                            }).then((response) => {
                                sessionStorage.setItem(LocalStorageKeys.USEREMAIL, response.account.username);
                                instance.setActiveAccount(response.account);
                                //getUserDetailsFromDb(response.account.username);
                            }).catch(() => {
                                if (inProgress === "none") {
                                    instance.loginRedirect({
                                        prompt: 'select_account',
                                        scopes: ["user.read"],
                                        loginHint: requestedLoginHint || undefined
                                    });
                                }
                            });
                        } else if (inProgress === "none") {
                            instance.loginRedirect({
                                prompt: 'select_account',
                                scopes: ["user.read"],
                                loginHint: requestedLoginHint || undefined
                            });
                        }
                    } else {
                        const activeAccountEmail = instance.getActiveAccount()?.username;
                        console.log('active account email', activeAccountEmail);
                        if (activeAccountEmail && activeAccountEmail !== null) {
                            sessionStorage.setItem(LocalStorageKeys.USEREMAIL, activeAccountEmail); 
                            //getUserDetailsFromDb(activeAccountEmail);
                        }
                    }

                })
                .catch((e) => {
                    console.log(e);
                });

        }
    }, [dispatch, inProgress, instance, isAuthenticated]);

    const getUserDetailsFromDb = (email) => {
        dispatch(getLoggedUserDetails(email))
            .then(res => {
                if (
                    !res ||
                    res.user === null ||
                    res.user === "null" ||
                    !res.user.isActive
                ) {
                    sessionStorage.clear();
                    localStorage.clear();

                    navigate("/pageNotfound", {
                        state: {
                            status: Congiguration.unauthorizedStatus,
                        },
                    });
                    return false;
                }
                SetLoggedInUserDataInSession(res);
            }).catch(e => { console.log(e); });
    }

    return (
        <div className="App">
            
                <div className="App">
                    <div className="container mt-3">
                        <Notification
                            open={networkAlertOpen}
                            onClose={() => setNetworkAlertOpen(false)}
                            message={networkAlertMessage}
                            severity="error"
                        />
                        {isAuthenticated && <Header />}
                        <Routes>
                            <Route exact path="/pageNotfound" element={<PageNotFound />} />
                            <Route exact path="/" element={<HomePage />} />
                            <Route exact path="/quoterequest" element={<QuoteRequest />} />
                            <Route exact path="/managebundles" element={<ManageBundles />} />
                            <Route exact path="/viewquote" element={<ViewRequest />} />
                            <Route exact path="/viewquotelink" element={<ViewRequestLink />} />
                            <Route exact path="/managedata" element={<ManageData />} />
                            <Route exact path="/manageusers" element={<ManageUsers />} />
                            <Route exact path="/countryquote" element={<CountryUploadValidation />} />
                            <Route exact path="/comparequote" element={<CompareQuote />} />
                            <Route exact path="/managesync" element={<ManageSync />} />
                        </Routes>
                        <Footer />
                    </div>
                </div>
            
        </div>
    );

};

const App = ({ instance }) => {

    return (

        <MsalProvider instance={instance}>
            <WappedViewForLogin />
        </MsalProvider>

    );
}

export default App;
